module.exports = __webpack_public_path__ + "static/media/nepal-government.09bdf849.png";